import { createOwnerActivationAnalytics } from './ownerActivationAnalyticsCore';
import type {
  AnalyticsProvider,
  OwnerActivationAnalytics,
  OwnerActivationAnalyticsPlatform,
} from './ownerActivationAnalyticsTypes';
import { isElectronRuntime } from '../utils/isElectron';

export type { OwnerActivationAnalytics } from './ownerActivationAnalyticsTypes';

/**
 * Web/Electron adapter.
 *
 * No remote analytics provider is configured for browser/Electron builds in
 * v1 (the Firebase web shim is a no-op), so this adapter is a deliberate
 * no-op provider that still validates/sanitizes through the same contract.
 *
 * `providerDeliversRemotely` is false so launch documentation cannot claim
 * remote delivery for these platforms. The provider itself cannot throw.
 */

function classifyWebPlatform(): OwnerActivationAnalyticsPlatform {
  try {
    return isElectronRuntime() ? 'electron' : 'web';
  } catch {
    return 'web';
  }
}

const noopProvider: AnalyticsProvider = {
  logEvent: () => undefined,
};

export const ownerActivationAnalytics: OwnerActivationAnalytics =
  createOwnerActivationAnalytics(noopProvider, classifyWebPlatform(), {
    providerDeliversRemotely: false,
  });

export default ownerActivationAnalytics;
